import { Button, Stack, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import axios from "../../config/axios";
import { LoadingButton } from "@mui/lab";

export const deleteComment = (commentId) => {
  return axios.delete(`comments/${commentId}`);
};

export default function RemoveComment({ handleClose, commentId }) {
  const queryClient = useQueryClient();
  const { vidId } = useParams();
  const { mutate, isLoading } = useMutation({
    mutationFn: deleteComment.bind(this, commentId),
    onSuccess: () => {
      handleClose();
      queryClient.invalidateQueries({ queryKey: ["comments", vidId] });
    },
  });

  return (
    <Stack>
      <Typography variant="h5" fontWeight={500} mb={1}>
        هل أنت متأكد من حذف التعليق؟
      </Typography>
      <Typography>لا يمكنك التراجع عن هذه الخطوة بعد التأكيد</Typography>
      <Stack flexDirection="row" gap={1} mt={4}>
        <LoadingButton
          loading={isLoading}
          size="small"
          variant="contained"
          onClick={mutate}
        >
          ازالة
        </LoadingButton>
        <Button
          size="small"
          variant="contained"
          onClick={handleClose}
          color="lightgrey"
        >
          الغاء
        </Button>
      </Stack>
    </Stack>
  );
}
